import React, {useEffect, useState} from "react";
import {connect} from "react-redux";


import GPAP_InfoIcon from "../../../gpap-lib/components/GPAP_InfoIcon";
import ErrorIcon from '@mui/icons-material/Error';
import Typography from "@mui/material/Typography";
import {LoadingComponent, loadingIcon} from "./LoadingComponent";
import GPAP_Tooltip from "../../../gpap-lib/components/GPAP_Tooltip";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';


// Reusable InfoBox component
const InfoBox = ({ icon, message }) => (
    <div style={{ float: "left", width: "95%" }}>
        <Typography
            variant="h6"
            style={{
                flex: '1 1 100%',
                color: "rgb(69, 117, 180)",
            }}
            component="div"
        >
            {icon} {message}
        </Typography>
    </div>
);

function ParticipantHeader(props){

    let {rowsL, total, setsAreEqual, loadingParticipants} = props;

    const s = `${rowsL} participant${rowsL !== 1 ? "s" : ""} with selected variant(s)`;


  if (loadingParticipants) {
    return <LoadingComponent />;
  }

   if (total === null) {
    return (
      <InfoBox
        icon={<ErrorIcon color="danger" />}
        message=" No Participants returned "
      />
    );
  }
   
  return (
    <>
      <InfoBox icon={null} message={s} />
      {setsAreEqual ? (
       <GPAP_Tooltip title="All Phenostore Entries were correctly returned">
          <CheckCircleIcon style={{ marginLeft: "8px", color: "green" }} />
        </GPAP_Tooltip>
      ) : (
         <GPAP_Tooltip title="Mismatch between requested and received participants">
          <DoNotDisturbOnIcon style={{ marginLeft: "8px", color: "#fca311" }} />
        </GPAP_Tooltip>
      )}
      <div>
        <GPAP_InfoIcon title="For technical limitations of our servers, we only display the first 1000 participants for a query. Please narrow your search if needed." />
      </div>
    </>
  );
}



//state here is store;
// map the store to the props of MainPanel component;
function mapStateToProps (state) {
    if(state.patients.length!==0)
    {
        return {
            token: state.authorization.token
        }
    }
    else{
        return {patients: [], token: state.authorization.token}
    }
}




export default connect(mapStateToProps,null)(ParticipantHeader);